// extracted by mini-css-extract-plugin
export var documentation = "_jt-1";
export var menu = "_jt-0";